<template>
  <div class="link-views white-bg">
    <div class="top">
      <Button class="mr" type="primary" @click="delCheckedFn">批量删除</Button>
    </div>
    <div class="select-div">
      <div class="mr">
        <span>选择实验：</span>
        <i-select v-model="pageData.ExpID" style="width:200px">
          <i-option v-for="item in ExpList" :value="item.ExpID" :key="item.ExpID">{{ item.ExpName }}</i-option>
        </i-select>
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="sureSearch(pageData.ExpID)">查询</Button>
        <Button type="primary" icon="md-refresh" @click="sureSearch(0)">重置</Button>
      </div>
    </div>
    <div class="table-div">
      <Table
        border
        ref="selection"
        :columns="columns"
        :data="listObj.Result"
        @on-selection-change="getTalkIdList"
      >
        <template slot-scope="{row}" slot="action">
          <div class="action-table">
            <a @click="delItemFn(row)">删除</a>
          </div>
        </template>
      </Table>
      <!-- 分页 -->
      <div class="page-div">
        <Page
          show-total
          :total="listObj.records"
          :current="pageData.page"
          :page-size="pageData.size"
          @on-change="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/home-api.js";
import * as allFn from "../../../utils/index.js";
export default {
  name: "message",
  data() {
    return {
      pageData: {
        ExpID: 0,
        page: 1,
        size: 10
      },
      columns: [
        { type: "selection", width: 60, align: "center" },
        { title: "评价时间", key: "CreateTime", align: "center" },
        { title: "评价人", key: "UserName", align: "center" },
        { title: "评价内容", key: "Content", className: "center" },
        { title: "相关实验名称", key: "ExpName", className: "center" },
        { title: "操作", slot: "action", align: "center" }
      ],
      listObj: {},
      TalkIdList: [],
      ExpList: []
    };
  },
  mounted() {
    this.getExpList();
    this.getTalkArr();
  },
  methods: {
     // 获取所有实验
    async getExpList() {
      this.ExpList = await homeApi.GetExperimentArr();
    },
    // 获取评价分页数据
    async getTalkArr() {
      this.listObj = await homeApi.GetTalkList({
        ExpID: this.pageData.ExpID ? this.pageData.ExpID : 0,
        page: this.pageData.page ? this.pageData.page : 0,
        size: this.pageData.size ? this.pageData.size : 0
      });
    },
    // 删除
    delItemFn(row) {
      this.$Modal.confirm({
        title: "删除评价",
        content: "确认删除" + row.Content,
        onOk: () => {
          homeApi.delTalk({ id: row.id }).then(res => {
            if (res.success) {
              this.pageData.page = 1;
              this.getTalkArr();
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        }
      });
    },
    // 获取需要删除的评价列表
    getTalkIdList(arr) {
      this.TalkIdList = arr.map(item => item.ExpTalkId);
    },
    // 确认删除选中的
    delCheckedFn() {
      this.$Modal.confirm({
        title: "批量删除评价",
        content: "确认所有选中的评价列表吗？",
        onOk: () => {
          homeApi.delCheckedTalk({ TalkIdList: this.TalkIdList }).then(res => {
            if (res.success) {
              this.pageData.page = 1;
              this.getTalkArr();
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        }
      });
    },
    // 分页
    changePage(page) {
      this.pageData.page = page;
      this.getTalkArr();
    },
    //搜索
    sureSearch(ExpID) {
      this.pageData.ExpID = ExpID;
      this.pageData.page = 1;
      this.getTalkArr();
    }
  }
};
</script>

<style scoped>
</style>